import {
  getLocalWeatherApi,
  getFutureWeatherApi,
  getWeatherReportApi,
  getWarningSummaryApi,
  getWarningInfoApi,
  getWeatherTipsApi,
} from "./backend";
import { AppSingleton } from "./user_config";

let instance;
let updateFrequencyMinutes = 10;
let globalState = {
  ts: Date.now(),
  localWeather: {},
  futureWeathers: [],
  weatherReport: {},
  warningSummary: {},
  warningInfo: {},
  weatherTips: [],
};

class WeatherData {
  constructor() {
    if (instance) {
      throw new Error("New instance cannot be created!!");
    }
    // this.updateWeather();
    globalState.ts = Date.now();
    instance = this;
  }

  getPropertyByName(propertyName) {
    return globalState[propertyName];
  }

  setPropertyValue(propertyName, propertyValue) {
    globalState[propertyName] = propertyValue;
  }

  get weather() {
    const appSingleton = new AppSingleton();
    appSingleton.setNotifications(["Weather Information: Updating"]);
    const ts = Date.now();
    return (async () => {
      if (
        ts - globalState.ts > 1000 * 60 * updateFrequencyMinutes ||
        Object.keys(globalState.localWeather).length === 0 ||
        Object.keys(globalState.weatherReport).length === 0 ||
        Object.keys(globalState.warningSummary).length === 0
      ) {
        console.log(
          `${ts - globalState.ts / 1000 / 60} minutes, fetching weather . . .`
        );
        globalState.ts = ts;
        await this.updateWeather();
        appSingleton.setNotifications(["Weather Information: Updated"]);
      }
      return {
        localWeather: globalState.localWeather,
        weatherReport: globalState.weatherReport,
        warningSummary: globalState.warningSummary,
      };
    })();
  }

  async _getWeather() {
    const response = await getLocalWeatherApi();
    globalState.localWeather = response;
    console.log(response);
  }

  async _getFutureWeather() {
    const response = await getFutureWeatherApi();
    globalState.futureWeathers = response.weatherForecast;
    console.log(response);
  }
  async _getWeatherReport() {
    const response = await getWeatherReportApi();
    globalState.weatherReport = response;
    console.log(response);
  }
  async _getWarningSummary() {
    const response = await getWarningSummaryApi();
    globalState.warningSummary = response;
    console.log(response);
  }
  async _getWarningInfo() {
    const response = await getWarningInfoApi();
    globalState.warningInfo = response;
    console.log(response);
  }
  async _getWeatherTips() {
    const response = await getWeatherTipsApi();
    globalState.weatherTips = response;
    console.log(response);
  }

  async updateWeather() {
    await this._getWeather();
    await this._getWeatherReport();
    await this._getWarningSummary();
  }
}

let WeatherDataInstance = Object.freeze(new WeatherData());

export default WeatherDataInstance;
